export function trackTmjEvent(event:string) {
  try {
    const consent=JSON.parse(localStorage.getItem("hill_medical_consent_v2") ?? "{}");
    if(consent.analytics_storage!=="granted") return;
    const analyticsWindow=window as Window & {dataLayer?:Record<string,string>[]};
    analyticsWindow.dataLayer?.push({event,booking_service:"tmj"});
  }catch { /* Consent is absent or invalid: do not send analytics. */ }
}
